import {createContext} from 'react';

export const WeedContext = createContext({});